<template lang="pug">
.page-container
  .forgot-container(:class="$mq", slot="foreground")
    .forgot(:class="$mq")
      h2.forgot-title Mot de passe oublié
      .forgot-form
        template(v-if="!emailSent")
          .form-group
            .label(autocomplete="on", for="email") Email
            v-text-field(
              v-model="email",
              type="email",
              placeholder="john.doe@example.com",
              :rules="[rules.required, rules.emailMatch]",
              validate-on-blur,
              dark
            )
          .description Un code te sera envoyé pour réinitialiser votre mot de passe.
        template(v-else-if="resetSuccess")
          .success Ton mot de passe a bien été réinitialisé !
        template(v-else)
          .form-group
            .label(autocomplete="on", for="code") Code
            v-text-field(
              v-model="code",
              placeholder="012345",
              :rules="[rules.required]",
              validate-on-blur,
              dark
            )
          .form-group
            .label(autocomplete="on", for="password") Nouveau mot de passe
            v-text-field(
              v-model="password",
              :append-icon="show1 ? 'visibility' : 'visibility_off'",
              :rules="[rules.required, rules.min]",
              :type="show1 ? 'text' : 'password'",
              name="input-10-2",
              placeholder="Mot de passe",
              @click:append="show1 = !show1",
              dark
            )

          .form-group
            .label(autocomplete="on", for="repeat-password") Répète ton mot de passe
            v-text-field(
              v-model="repeatPassword",
              :append-icon="show2 ? 'visibility' : 'visibility_off'",
              :rules="[rules.required, rules.samePassword, rules.min]",
              :type="show2 ? 'text' : 'password'",
              name="input-10-2",
              label="Repetez mot de passe",
              @click:append="show2 = !show2",
              dark
            )
        .error-msg {{ errorMsg }}
      button.button-send(v-if="!emailSent", @click="sendEmail") Envoyer le code
      template(v-else-if="!resetSuccess")
        button.button-send(@click="submitForgot") Réinitialiser
        .forgot-password(@click="sendEmail") Renvoyer un code
</template>

<script>
import { Auth } from 'aws-amplify'

const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i

export default {
  name: 'ForgotPassword',
  data () {
    return {
      errorMsg: '',
      email: '',
      code: '',
      show1: false,
      password: '',
      show2: false,
      repeatPassword: '',
      emailSent: false,
      resetSuccess: false,
      rules: {
        required: value => !!value || 'Requis',
        min: v => v.length >= 8 || '8 caracteres minimum',
        emailMatch: v => re.test(v) || 'Veuillez renseigner une adresse email valide',
        samePassword: v => v === this.password || 'Les deux mots de passe sont différents'
      }
    }
  },
  methods: {
    checkPasswords (v) {
      return v === this.password
    },
    sendEmail () {
      this.errorMsg = ''
      if (!re.test(this.email)) {
        // this.errorMsg = 'Veuillez renseigner une adresse email valide'
        return
      }

      Auth.forgotPassword(this.email)
        .then(() => {
          this.emailSent = true
        })
        .catch(err => {
          if (err.code === 'UserNotFoundException') {
            this.errorMsg = 'Cette adresse email ne correspond à aucun utilisateur'
          } else {
            this.errorMsg = 'Erreur inconnue'
          }
          console.error(err)
        })
    },
    submitForgot () {
      this.errorMsg = ''
      // if (this.code === null || this.name.length === 0) {
      //   this.errorMsg = 'Veuillez entrer un prénom'
      //   return
      // }
      if (this.password !== this.repeatPassword) {
        this.errorMsg = 'Les deux mot de passes sont différents'
        return
      }
      if (this.password.length < 8) {
        this.errorMsg = 'Le mot de passe doit faire au moins 8 charactères'
        return
      }

      Auth.forgotPasswordSubmit(this.email, this.code, this.password)
        .then(() => {
          this.resetSuccess = true
        })
        .catch(err => {
          if (err.code === 'ExpiredCodeException') {
            this.errorMsg = 'Ce code a déjà été utilisé'
          } else if (err.code === 'CodeMismatchException') {
            this.errorMsg = 'Ce code est expiré'
          } else {
            this.errorMsg = 'Échec lors de la réinitialization'
          }
          console.error(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@/styles/colors.scss";

.page-container {
  width: 100%;
  min-height: 100vh;
  overflow: auto;
  color: white;
  background-image: linear-gradient(
    100deg,
    colors.$intense-purple,
    colors.$light-purple-gradient
  );

  .forgot-container {
    max-width: 80%;
    max-width: 1000px;
    padding-top: 30px;
    margin: auto;
  }
}

.forgot {
  height: 100%;
  display: grid;
  align-content: center;
  justify-content: center;
  grid-template-columns: minmax(350px, 60%);

  &.large-desktop,
  &.desktop,
  &.tablet-landscape {
    grid-template-rows: 80px auto 100px auto;
  }

  &.tablet-portrait,
  &.phone {
    grid-template-rows: 80px auto 70px auto;
    margin: 40px 0 20px 0;
  }

  .forgot-title {
    color: white;
    font-size: 38px;
  }

  .description {
    // color: $dark-sky-blue;
    font-size: 18px;
    margin: 10px 0 0 0;
    text-align: center;
    font-style: italic;
  }

  .label {
    text-align: left;
    color: white;
    font-size: 24px;
    padding: 10px 0 0px 0;
  }

  .error-msg {
    color: colors.$moon-yellow;
    height: 1.5em;
    padding-top: 20px;
    height: 50px;
    text-align: center;
  }

  .button-send {
    padding: 0px 30px;
    border-radius: 46.5px;
    background-color: white;
    color: colors.$intense-purple;
    font-size: 36px;
    border: none;
    outline: none;
  }

  .forgot-password {
    padding-top: 15px;
    color: white;
    margin: auto;
    cursor: pointer;
  }
}

.success-container {
  min-height: 400px;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 80%;
  grid-row-gap: 20px;
  justify-content: center;
  align-content: center;
  text-align: center;
  font: Nunito, Arial, sans-serif;
  font-size: 24px;
  color: colors.$intense-purple;
}

.success-main {
  font-size: 30px;
}
</style>
